export const setLocalStorageEmail = (email) =>{
    window.localStorage.setItem('email', email);
}

export const setLocalStorageLoginToken = (loginToken) =>{
    window.localStorage.setItem('loginToken', loginToken);
}

export const setLocalStorageJwtToken = (jwtToken) =>{
    window.localStorage.setItem('jwtToken', jwtToken);
}

export const setLocalStorageProfilePic = (profilePic) =>{
    window.localStorage.setItem('profilePic', profilePic);
}

export const clearLocalStorage = () => {
    window.localStorage.clear();
}